module.exports = __webpack_public_path__ + "static/media/explainer.493da5db.png";